import { type Tag } from '@app/client/common/structs';

import { removeDupsWithinAppCurrencies } from '../removeDuplicateCurrencyTags';

export interface NewWalletTags {
    newAddressTags: Tag[];
    newAddressesOfExistingTags: Tag[];
    newAddressesAlreadyAdded: Tag[];
}

export const newWalletAddressesExist = (
    newAddresses: Tag[],
    existingTags: Tag[],
    currencyTypes: string[],
): NewWalletTags => {
    if (newAddresses?.length && (!existingTags || !existingTags?.length)) {
        return {
            newAddressTags: removeDupsWithinAppCurrencies(newAddresses, currencyTypes),
            newAddressesOfExistingTags: [],
            newAddressesAlreadyAdded: [],
        };
    }
    const existingAddressTags: Tag[] = existingTags.filter((t) => currencyTypes.includes(t.tag));

    const newAddressTags: Tag[] = [];
    const newAddressesOfExistingTags: Tag[] = [];
    const newAddressesAlreadyAdded: Tag[] = [];

    newAddresses.forEach((newTag) => {
        const matchingTag = existingAddressTags.find(
            (oldTag) => oldTag.tag === newTag.tag && oldTag.data.toLowerCase() === newTag.data.toLowerCase(),
        );
        const tag = { tag: newTag.tag, data: newTag.data } as unknown as Tag;

        if (!matchingTag) {
            newAddressTags.push(tag);
        } else {
            newAddressesAlreadyAdded.push(tag);
        }
    });

    newAddressTags.forEach((newTag) => {
        const oldTagMatchNewAddress = (oldTag) =>
            oldTag.tag === newTag.tag && oldTag.data.toLowerCase() !== newTag.data.toLowerCase();
        if (existingAddressTags.find(oldTagMatchNewAddress)) {
            newAddressesOfExistingTags.push({ tag: newTag.tag, data: newTag.data } as unknown as Tag);
        }
    });

    return {
        newAddressTags: removeDupsWithinAppCurrencies(newAddressTags, currencyTypes),
        newAddressesOfExistingTags: removeDupsWithinAppCurrencies(newAddressesOfExistingTags, currencyTypes),
        newAddressesAlreadyAdded: removeDupsWithinAppCurrencies(newAddressesAlreadyAdded, currencyTypes),
    };
};
